import {
    getEstimatedDeliveryDate,
    EddModal,
    EddResponseModal,
    ItemsEdd,
} from "@NA/Services/ADIEstimatedDeliveryService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    HasOnSuccess,
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<EddModal & HasOnSuccess<EddResponseModal>, EddResponseModal>;

export const DispatchStartloadingEddMethods: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/GetEddMethods",
        result: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getEstimatedDeliveryDate(props.parameter);
};

export const DispatchCompleteloadEddMethods: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
    props.dispatch({
        type: "Custom/loadEddMethods",
        eddMethods: props.apiResult,
    });
}
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [DispatchStartloadingEddMethods, PopulateApiParameter, RequestDataFromApi, DispatchCompleteloadEddMethods, ExecuteOnSuccessCallback];

const loadEddMethods = createHandlerChainRunner(chain, "loadEddMethods");
export default loadEddMethods;
